const stockDivs = document.querySelectorAll('.qty-wrapper');
const stock__dot = document.querySelectorAll('#stock__dot');
const stock__desc = document.querySelectorAll('#stock__desc');
const stock__additional = document.querySelectorAll('#stock__additional');
let isVariantSelected = false;


  const handleStockChange = () => {
    stockDivs.forEach((stockDiv, index) => {
      const stockValue = stockDiv.getAttribute('data-stock');

      if (isVariantSelected) {
        if (stockValue >= 1) {
          stock__desc.forEach(desc => desc.innerHTML = 'Dostępny');
          stock__dot.forEach(dot => {
            dot.classList.remove('bg-notRed');
            dot.classList.add('bg-notGreen');
          });
          stock__desc.forEach(desc => {
            desc.classList.remove('!text-notRed');
            desc.classList.add('!text-notGreen');
          });

          if (stockValue == 1) {
            stock__additional.forEach(additional => additional.innerHTML = 'Ostatnia sztuka');
          }
          if (stockValue == 2) {
            stock__additional.forEach(additional => additional.innerHTML = 'Ostatnie 2 sztuki');
          }
          if (stockValue > 2) {
            stock__additional.forEach(additional => additional.innerHTML = '');
          }
        } else {
          stock__desc.forEach(desc => desc.innerHTML = 'Niedostępny');
          stock__dot.forEach(dot => {
            dot.classList.remove('bg-notGreen');
            dot.classList.add('bg-notRed');
          });
          stock__additional.forEach(additional => additional.innerHTML = '');
          stock__desc.forEach(desc => {
            desc.classList.remove('!text-notGreen');
            desc.classList.add('!text-notRed');
          });
        }
      }
    });
  };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      const stockDiv = mutation.target;
      const stock__dot = stockDiv.querySelector('#stock__dot');
      const stock__desc = stockDiv.querySelector('#stock__desc');
      const stock__additional = stockDiv.querySelector('#stock__additional');
      handleStockChange(stockDiv, stock__dot, stock__desc, stock__additional);
    });
  });

  stockDivs.forEach(stockDiv => {
    observer.observe(stockDiv, { attributes: true, attributeFilter: ['data-stock'] });
  });


const customOptions = document.querySelectorAll('.custom_option');
customOptions.forEach(customOption => {
  customOption.addEventListener('click', () => {
    isVariantSelected = true;
  });
});

// Obsługa po załadowaniu strony
document.addEventListener('DOMContentLoaded', () => {
  if (stockDivs) {
    isVariantSelected = true;
    handleStockChange();
  }
});
